import classnames from "classnames"

import style from "./Spinner.module.scss"

type SpinnerProps = {
  className?: string
}

const Spinner = ({ className }: SpinnerProps) => <div className={classnames(style.spinner, className)} />

export default Spinner
